import React from 'react'
import Checkbox from 'app/components/checkbox'
import { VerdictBadge } from 'app/components/verdict-badge'
import { ThreatIndicatorsCategory } from 'app/modules/reports/types'

export interface IndicatorTypeItemProps {
  type: ThreatIndicatorsCategory
  isOpen: boolean
  isSelected: boolean
  selectedIndicators: string[]
  onOpenAccordion: (type: string) => void
  onSelectType: (type: string) => void
  onSelectIndicator: (indicator: string) => void
}

export const IndicatorTypeItem: React.FC<Readonly<IndicatorTypeItemProps>> = ({
  type,
  isOpen,
  isSelected,
  selectedIndicators,
  onOpenAccordion,
  onSelectType,
  onSelectIndicator,
}) => (
  <div className="indicators-list-element d-block">
    <div className="indicators-type-accordion-title" onClick={() => onOpenAccordion(type.type)}>
      <Checkbox
        labelClassName="text-muted text-m"
        label={`${type.name} (${type.groups.length})`}
        onChange={() => onSelectType(type.type)}
        checked={isSelected}
      />
      <div className="d-flex flex-grow-1 justify-content-end pe-2">
        <i className={`ds3-icon ${isOpen ? 'ds3-solid-down' : 'ds3-solid-right'}`} />
      </div>
    </div>
    <div className={isOpen ? '' : 'd-none'}>
      {type.groups.map((group) => (
        <IndicatorGroup
          key={group.id}
          selected={selectedIndicators.includes(group.id)}
          name={group.id}
          description={group.description}
          onSelect={() => onSelectIndicator(group.id)}
          strength={group.strength}
        />
      ))}
    </div>
  </div>
)

export interface IndicatorGroupProps {
  selected: boolean
  name: string
  description?: string
  strength?: number
  onSelect: () => void
}

export const IndicatorGroup: React.FC<Readonly<IndicatorGroupProps>> = ({
  selected,
  name,
  description,
  strength,
  onSelect,
}) => (
  <div className="threat-indicator-group-line">
    <div className="threat-indicator-group-labels">
      <Checkbox labelClassName="text-muted" className="w-25" checked={selected} label={name} onChange={onSelect} />
      <span className="text-main text-muted">{description}</span>
    </div>
    {strength ? <VerdictBadge strength={strength} variant="secondary" /> : null}
  </div>
)
